document.addEventListener("DOMContentLoaded", function () {
  var ns = window.EM.booking;
  var cfg = ns.config;
  var st = ns.state;

  if (!cfg || cfg.isCamp) return;

  if (cfg.isLocationEvent) {
    $(".section-filters").hide();
  }

  ns.url.bindPopState();
  ns.filters.bindHandlers();
  ns.book.bindHandlers();

  function onFinishedLoading() {
    ns.calendar.addSpinner({ clear: true });

    var _state = ns.url.stateFromQuery();
    st.patch(_state);

    if (DEVELOPMENT) {
      console.log("State From Query: " + JSON.stringify(st.get()));
    }

    var state = st.get();

    if (Object.keys(state).length > 0) {
      if (state.action === "complete") {
        window.location = cfg.PAGE_CALENDAR;
        return;
      }
    }

    if (state["bsource"]) {
      delete state["bsource"];
      var url = cfg.PAGE_CALENDAR + ns.url.queryFromState(state);

      if (cfg.ENABLE_PUSHSTATE && history.pushState) {
        history.replaceState(state, document.title, url);
      } else {
        setTimeout(function () {
          window.location = url;
        }, 250);
        return;
      }
    }

    if (state.action === "calendar") {
      st.setFinishedLoading(true);
      ns.calendar.updateCalendar();
    } else if (state.action === "book") {
      state.start = state.date;
      state.end = moment.tz(state.start, "YYYYMMDD", cfg.VENUE_TZ).add(cfg.DATES_PER_FETCH, "days").format("YYYYMMDD");
      ns.data.getBookings(state)
        .done(function () {
          ns.book.showBook({ refreshHtmlOnly: false, skipUpdateUrl: true });
          st.setFinishedLoading(true);
        })
        .fail(function () {
          $(".booking-dates").empty();
          $(".connection-error").clone().show().appendTo(".booking-dates");
          st.setFinishedLoading(true);
        });
    } else {
      st.setFinishedLoading(true);
    }

    ns.calendar.bindScrollListener();
  }

  onFinishedLoading();
});
